import script from "./UCHealth.vue?vue&type=script&setup=true&lang=js"
export * from "./UCHealth.vue?vue&type=script&setup=true&lang=js"

import "./UCHealth.vue?vue&type=style&index=0&id=5ad6dcfb&lang=scss&scoped=true"
import "./UCHealth.vue?vue&type=style&index=1&id=5ad6dcfb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad6dcfb"]])

export default __exports__